import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListBullets1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "list-bullets-1_icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M8.5 5H23a1 1 0 1 0 0-2H8.5a1 1 0 0 0 0 2" }),
		/* @__PURE__ */ _jsx("path", { d: "M23 11H8.5a1 1 0 0 0 0 2H23a1 1 0 0 0 0-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M23 19H8.5a1 1 0 0 0 0 2H23a1 1 0 0 0 0-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M1.5 2.5h2s.5 0 .5.5v2s0 .5-.5.5h-2S1 5.5 1 5V3s0-.5.5-.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.5 1.5h-2A1.5 1.5 0 0 0 0 3v2a1.5 1.5 0 0 0 1.5 1.5h2A1.5 1.5 0 0 0 5 5V3a1.5 1.5 0 0 0-1.5-1.5M4 5a.5.5 0 0 1-.5.5h-2A.5.5 0 0 1 1 5V3a.5.5 0 0 1 .5-.5h2A.5.5 0 0 1 4 3z" }),
		/* @__PURE__ */ _jsx("path", { d: "M1.5 10.5h2s.5 0 .5.5v2s0 .5-.5.5h-2s-.5 0-.5-.5v-2s0-.5.5-.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.5 9.5h-2A1.5 1.5 0 0 0 0 11v2a1.5 1.5 0 0 0 1.5 1.5h2A1.5 1.5 0 0 0 5 13v-2a1.5 1.5 0 0 0-1.5-1.5M4 13a.5.5 0 0 1-.5.5h-2A.5.5 0 0 1 1 13v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M1.5 18.5h2s.5 0 .5.5v2s0 .5-.5.5h-2s-.5 0-.5-.5v-2s0-.5.5-.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.5 17.5h-2A1.5 1.5 0 0 0 0 19v2a1.5 1.5 0 0 0 1.5 1.5h2A1.5 1.5 0 0 0 5 21v-2a1.5 1.5 0 0 0-1.5-1.5M4 21a.5.5 0 0 1-.5.5h-2A.5.5 0 0 1 1 21v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5z" })
	]
});
export { SvgListBullets1 as ReactComponent };
